import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Card from "../../user/components/Card";
import { Placeholder } from "rsuite";
import { GetBanners } from "../../user/services/cms.service";
import { getTrendingProducts, favouriteUnfavouriteProduct } from "../../user/services/product.services";
import ShoplistSelectModal from "../../user/components/ShoplistSelectModal";
import { SKELETON_LOADING_TIME, ROLE, SWAL_SETTINGS } from "../../../utils/Constants";
import StreamsSection from "../shared/StreamsSection";
import DownloadAppSection from "../shared/DownloadAppSection";
import GoogleAd from "../../user/components/GoogleAd";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { getUser, isGuest, isUserLoggedIn, showLoginRequiredModal } from "../../../utils/commonfunction";
import Swal from "sweetalert2";


function Home() {
  const [bannerLoaded, setBannerLoaded] = React.useState(false);
  const [banners, setBanners] = React.useState([]);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const user = getUser(ROLE.USER);
  const [modalProduct, setModalProduct] = useState(null);
  const [isShoplistModalOpen, setIsShoplistModalOpen] = useState(false);

  const [globalData, setGlobalData] = useState({});
  const myGlobalData = useSelector((state) => state.globalData);
  useEffect(() => {
    if (myGlobalData && myGlobalData?.data) {
      const settingsData = JSON.parse(myGlobalData?.data);
      setGlobalData(settingsData);
    }
  }, [myGlobalData]);

  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour >= 5 && hour < 12) return t("dashboard.greeting.morning", "Good Morning");
    if (hour >= 12 && hour < 17) return t("dashboard.greeting.afternoon", "Good Afternoon");
    if (hour >= 17 && hour < 21) return t("dashboard.greeting.evening", "Good Evening");
    return t("dashboard.greeting.night", "Good Night");
  };
  const settings = {
    dots: true, // hide dots navigation
    infinite: true, // loop slides
    speed: 1000, // transition speed (ms)
    slidesToShow: 1, // show one slide at a time
    slidesToScroll: 1, // scroll one per change
    autoplay: true, // enable auto slide
    autoplaySpeed: 4000, // time between slides
    fade: true, // ✅ enable fade effect
    cssEase: "linear", // smooth fade transition
    arrows: false, // optional - hide next/prev arrows
  };

  const [trendingProducts, setTrendingProducts] = useState([]);
   useEffect(() => {
    getTrendingProducts()
      .then((res) => {
        if (res.success) {
          setTrendingProducts(res.data);
        }
      })
      .catch((err) => {
        console.error("Error fetching trending products:", err);
      });

    GetBanners().then((res) => {
      if (res.success) {
        setBanners(res.data);
      }
    }).catch((err) => {
      console.error(err);
    }).finally(() => {
      setTimeout(() => {
        setBannerLoaded(true);
      }, SKELETON_LOADING_TIME);
    });

    if (location.state?.loginSuccessful) {
      Swal.fire({
        icon: "success",
        text: location.state.message || "Successfully logged in",
        ...SWAL_SETTINGS,
      });
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location, navigate]);

  const handleLikeFavouriteProduct = async (item) => {
    const currentUser = getUser(ROLE.USER);
    const isLoggedIn = Boolean(
      currentUser && 
      (currentUser._id || currentUser.id || currentUser.token) && 
      !isGuest()
    );

    if (!isLoggedIn) {
      Swal.fire({
        icon: "warning",
        title: t("common.login_required"),
        text: t("common.login_required_to_favorite", { defaultValue: "Please login to add to favourites" }),
        showCancelButton: true,
        confirmButtonColor: "var(--primary-400, #ff4081)",
        cancelButtonColor: "#71717a",
        confirmButtonText: t("link_login", { defaultValue: "Login" }),
        cancelButtonText: t("product_details.close", { defaultValue: "Close" }),
      }).then((result) => {
        if (result.isConfirmed) {
          const currentPath = window.location.pathname + window.location.search;
          navigate(`/user/login?redirect=${encodeURIComponent(currentPath)}`);
        }
      });
      return;
    }
    const productId = item?.product_id || item?._id;
    setModalProduct({ ...item, _id: productId });
    setIsShoplistModalOpen(true);
  };

  const handleShoplistSaved = (savedShoplistIds) => {
    if (modalProduct) {
      const isFav = Array.isArray(savedShoplistIds) && savedShoplistIds.length > 0;
      const targetId = modalProduct?._id;
      setTrendingProducts((prev) =>
        prev.map((p) => {
          const pId = p?.product_id || p?._id;
          return pId === targetId
            ? {
                ...p,
                isFavourite: isFav,
                isFavouriteProduct: isFav,
              }
            : p;
        })
      );
    }
  };


  return (
    <div className="home-bg">
      <div className="container-fluid !px-[15px] xl:!px-[40px] 2xl:!px-[80px] pt-4">
        {user && user.name && (
          <div className="mb-2">
            <h2 className="text-2xl font-semibold text-zinc-800">
              {getGreeting()}, {user.name}!
            </h2>
          </div>
        )}
      </div>


      {String(globalData?.banner_visibility) !== "false" && (
        <section className="banner-section overflow-hidden mt-[15px] md:mt-[30px]">
          <div className="container-fluid !px-[15px] xl:!px-[40px] 2xl:!px-[80px]">
            {
              bannerLoaded ?
                <Slider {...settings}>
                  {banners.map((record, i) => (
                    <div key={i}>
                      <img
                        src={record?.image}
                        alt={`Slide ${i + 1}`}
                        className="w-full h-auto object-contain rounded-[16px]"
                      />
                    </div>
                  ))}
                </Slider>
                :
                <Placeholder.Graph className="w-full website-placeholder rounded-[16px] min-h-[89vh]" active={true} />
            }
          </div>
        </section>
      )}




      {/* <section className="pt-10 md:pt-16 lg:pt-24 bg-white">
        <div className="container">
          <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16"> 
            <div className="w-full lg:w-1/2">
              <img
                src="/images/about.png"
                alt="The Live Shop Platform"
                className="w-full rounded-2xl object-cover shadow-lg"
              />
            </div>
 
            <div className="w-full lg:w-1/2 flex flex-col gap-5">
              <h2 className="heading-web-h2 text-[var(--black-scale-900)]">
                About <span className="text-[var(--primary-400)]">The Live Shop</span>
              </h2>
              <p className="text-zinc-500 body-sm !leading-relaxed">
                The Live Shop is a live advertising platform that enables businesses &amp; brands to showcase and sell products through interactive live shopping experiences.
              </p>
              <p className="text-zinc-500 body-sm !leading-relaxed">
                Our platform brings together live video, product discovery, allowing customers to discover products, interact during live sessions, and shop online directly with advertisers.
              </p>
            </div>
          </div>
        </div>
      </section> */}


    
          <section className="trending-products-section bg-white py-8 md:py-12 lg:py-24 !pt-0">
            <div className="container">
              <div className="section-head flex justify-between items-center gap-[10px] mb-8 flex-wrap">
                <h2 className="heading-web-h2 text-[var(--black-scale-900)]">{t("home.heading_trending_products")}</h2>
                {/* <a className="link">{t("home.btn_view_all")}</a> */}
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-[30px]">
                {trendingProducts.length > 0 ? (
                  trendingProducts?.map((item, index) => {
                    const productId = item?.product_id || item?._id;
                    const isLiked = Boolean(item?.isFavourite || item?.isFavouriteProduct);
                    return (
                      <div
                        onClick={() => {
                          const targetUrl = `/user/product-details?o_id=${productId}`;
                          if (!isUserLoggedIn()) {
                            showLoginRequiredModal({
                              navigate,
                              redirectUrl: targetUrl,
                            });
                            return;
                          }
                          navigate(targetUrl);
                        }}
                        key={productId || index}
                        className="cursor-pointer"
                      >
                        <Card
                          images={item?.compressed_image || item?.image}
                          compressedImage={item?.compressed_image}
                          originalImage={item?.image}
                          title={item?.title}
                          subtitle={item?.seller?.name}
                          price={item?.price}
                          isAskForPrice={item?.isAskForPrice}
                          time={false}
                          live={false}
                          isLiked={isLiked}
                          onLikeClick={(e) => {
                            e.stopPropagation();
                            handleLikeFavouriteProduct(item);
                          }}
                        />
                      </div>
                    );
                  })
                ) : (
                  <div className="col-span-full text-center py-10 text-gray-500 text-lg">
                    {t("home.no_trending_products_found", "No Trending Products Found")}
                  </div>
                )}
              </div>
            </div>
          </section>

          {/* Google AdSense Responsive Ad */}
          <div className="container mx-auto px-4 my-6">
            <GoogleAd />
          </div>


      {String(globalData?.home_section_visibility) !== "false" ? (
        <>
          <StreamsSection className="upcoming-streams-section bg-white py-8 md:py-12 lg:py-24" />


          <StreamsSection title={t("home.heading_upcoming_streams")} type="upcoming" className="upcoming-streams-section bg-white py-8 md:py-12 lg:py-24" />



          <StreamsSection title={t("home.heading_past_streams")} type="past" className="upcoming-streams-section bg-white py-8 md:py-12 lg:py-24" />

          <DownloadAppSection />

          <section className="pt-8 pb-8 md:pt-12 lg:pt-24 bg-white">
            <div className="container">
              <div className="lg:w-full">
                {/* <h2 className="heading-web-h2 text-[var(--black-scale-900)] mb-6">{t("home.heading_about_us")}</h2> */}
                <h2 className="heading-web-h2 text-[var(--black-scale-900)] mb-6">
                  About <span className="text-[var(--primary-400)]">The Live Shop</span>
                </h2>
                <p className="text-zinc-500 mt-0 mb-2 body-sm !text-base !leading-relaxed">
                  {t("home.description_about_us_p1")}
                </p>
                <p className="text-zinc-500 mt-0 body-sm mb-2 !text-base !leading-relaxed">{t("home.description_about_us_p2")}</p>
                <p className="text-zinc-500 mt-0 body-sm !text-base !leading-relaxed">{t("home.description_about_us_p3")}</p>
              </div>
            </div>
          </section>

        </>
      ) : (
        <section className="coming-soon-section bg-white py-16 md:py-24 text-center">
          <div className="container">
            <h2 className="heading-web-h2 text-[var(--black-scale-900)] mb-4">{t("home.coming_soon", "Coming Soon")}</h2>
            <p className="text-zinc-500 text-lg max-w-2xl mx-auto">{t("home.coming_soon_desc", "Exciting live streams and amazing products are coming to this space very soon. Stay tuned!")}</p>
          </div>
        </section>
      )}

      {modalProduct && (
        <ShoplistSelectModal
          isOpen={isShoplistModalOpen}
          product={modalProduct}
          onClose={() => {
            setIsShoplistModalOpen(false);
            setModalProduct(null);
          }}
          onSaved={handleShoplistSaved}
        />
      )}
    </div>
  );
}

export default Home;
